import api from './api';

/**
 * Cargas familiares vigentes de la empresa, desde el Excel "Trabajadores con Cargas
 * Autorizadas por IPS" de Previred.
 */

export const getCargasFamiliares = (idCompany) =>
  api.get('/api/rrhh/cargas-familiares', { params: { id_company: idCompany } })
    .then(r => r.data.data);

export const cargarExcelCargasFamiliares = (idCompany, archivo) => {
  const formData = new FormData();
  formData.append('file', archivo);
  formData.append('id_company', idCompany);
  return api.post('/api/rrhh/cargas-familiares/excel', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }).then(r => r.data);
};
